module.exports = __webpack_public_path__ + "static/media/blogpost2.6b03296f.png";